import React, { useState } from "react";
import { useSelector } from "react-redux";
import { jsPDF } from "jspdf";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const AgriLinkDB = () => {
  const authState = useSelector((state) => state.authReducer);
  const [certificateNumber, setCertificateNumber] = useState("");
  const [certificateData, setCertificateData] = useState(null);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (certificateNumber.length !== 16) {
      setIsError(true);
      setMessage("❌ Please enter a valid 16-character Certificate Number.");
      setCertificateData(null);
      return;
    }

    const mockCertificate = {
      certificateNumber,
      farmerName: "Sanjeev Kumar",
      farmName: "Kisan Pragati Agro Farm",
      fatherOrGuardian: "Ramesh Kumar",
      registrationDate: "2023-04-25",
      validity: "2028-04-24",
      category: "Small Farmer / Agri Entrepreneur",
      farmerID: "AGRI-UP-09-0005678",
      location: "Karnal District, Haryana, India",
      cropsOrActivity: "Wheat, Rice, Dairy",
      status: "Active",
    };

    setCertificateData(mockCertificate);
    setMessage("✅ Certificate Found in Think5Whys SAKSHAM AgriLink Database.");
    setIsError(false);
  };

  const downloadPDF = () => {
    if (!certificateData) return;

    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("🌱 Think5Whys AgriLink Certificate", 20, 20);
    doc.setFontSize(12);

    const fields = [
      `Certificate Number: ${certificateData.certificateNumber}`,
      `Farmer Name: ${certificateData.farmerName}`,
      `Farm Name: ${certificateData.farmName}`,
      `Crops/Activity: ${certificateData.cropsOrActivity}`,
      `Father/Guardian: ${certificateData.fatherOrGuardian}`,
      `Farmer ID: ${certificateData.farmerID}`,
      `Registration Date: ${certificateData.registrationDate}`,
      `Valid Upto: ${certificateData.validity}`,
      `Status: ${certificateData.status}`,
      `Location: ${certificateData.location}`,
    ];

    fields.forEach((field, i) => doc.text(field, 20, 30 + i * 10));

    doc.save(`Certificate_${certificateData.certificateNumber}.pdf`);
  };

  return (
    <section className="py-16 px-4 sm:px-6 md:px-20 bg-black min-h-screen flex items-center">
      <div className="bg-black border border-green-300 p-8 sm:p-10 rounded-2xl max-w-3xl mx-auto w-full shadow-xl">
        <h3 className="text-lg lg:text-xl font-bold text-yellow-200 mb-2 text-center">
          Think5Whys AgriLink Database
        </h3>
        <p className="mb-6 text-white text-center">
          Enter your 16-character Certificate Number to verify your registration
        </p>

        <form onSubmit={handleSubmit} className="flex justify-center mb-6">
          <div className="flex flex-col sm:flex-row items-center gap-3 w-full max-w-md">
            <input
              type="text"
              placeholder="Enter Certificate Number"
              value={certificateNumber}
              onChange={(e) => setCertificateNumber(e.target.value.toUpperCase())}
              className="w-full px-4 py-2 text-black border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-500 text-center tracking-widest"
              maxLength={16}
            />
            <button
              type="submit"
              className="w-full mt-4 sm:w-auto px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition"
            >
              Search
            </button>
          </div>
        </form>

        {message && (
          <p
            className={`mt-2 text-center text-sm font-medium ${
              isError ? "text-red-300" : "text-yellow-200"
            }`}
          >
            {message}
          </p>
        )}

        {certificateData && !isError && (
          <div className="mt-8 bg-black text-white border-4 border-green-400 rounded-xl p-6 shadow-inner">
            <h4 className="text-sm lg:xl font-semibold text-yellow-200 mb-4 text-center">
              🌱 Think5Whys AgriLink Certificate Details
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm lg:text-lg text-gray-300">
              <p><strong>Certificate Number:</strong> {certificateData.certificateNumber}</p>
              <p><strong>Farmer Name:</strong> {certificateData.farmerName}</p>
              <p><strong>Farm Name:</strong> {certificateData.farmName}</p>
              <p><strong>Crops/Activity:</strong> {certificateData.cropsOrActivity}</p>
              <p><strong>Father/Guardian:</strong> {certificateData.fatherOrGuardian}</p>
              <p><strong>Farmer ID:</strong> {certificateData.farmerID}</p>
              <p><strong>Registration Date:</strong> {certificateData.registrationDate}</p>
              <p><strong>Valid Upto:</strong> {certificateData.validity}</p>
              <p>
                <strong>Status:</strong>{" "}
                <span className="text-green-600 font-semibold">{certificateData.status}</span>
              </p>
              <p className="sm:col-span-2"><strong>Location:</strong> {certificateData.location}</p>
            </div>

            {/* Single Download PDF Button */}
            <div className="mt-6 flex justify-center">
              <button
                onClick={downloadPDF}
                className="flex items-center gap-2 w-48 px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition"
              >
                <FontAwesomeIcon icon={faDownload} /> Download PDF
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default AgriLinkDB;
